export const SERVER_ERRORS = {

  // AUTHORIZATION_ERROR
  MISSING_TOKEN: 'AUTH0101',
  INVALID_TOKEN: 'AUTH0102',
  INVALID_ID_TOKEN: 'AUTH0103',
  MISSING_ID_TOKEN: 'AUTH0104',
  USER_NOT_AUTHORIZED: 'AUTH0105',
  USER_NO_RELATIONSHIP: 'AUTH0106',

  // VALIDATION_ERROR
  MISSING_POUCH_ID: 'VAL0101',
  MISSING_PATIENT_ID: 'VAL0102',
  INVALID_FIELDS: 'VAL0103',
  NO_QUESTIONS_FOR_QUESTIONNAIRE: 'VAL0104',
  INVALID_SCHED_CHANGE_ACKOWLEDGE: 'VAL0105',
  CANNOT_SET_UPDATE: 'VAL0106',
  COULD_NOT_FOUND_PACKAGE: 'VAL0134',

  // REPOSITORY_ERROR
  NO_SCHEDULE_FOR_ID: 'REP0101',
  COULD_NOT_INSERT_DEVICE_INFO: 'REP0102',
  COULD_NOT_FIND_USER: 'REP0103',
  COULD_NOT_UPDATE_USER: 'REP0104',
  COULD_NOT_CREATE_USER: 'REP0105',
  NO_QUESTIONNAIRE_FOR_ID: 'REP0106',
  COULD_NOT_CREATE_QUESTIONNAIRE: 'REP0107',
  COULD_NOT_UPDATE_QUESTIONNAIRE: 'REP0108',
  COULD_NOT_DELETE_QUESTIONNAIRE: 'REP0109',
  COULD_NOT_CREATE_QUESTION: 'REP0110',
  COULD_NOT_UPDATE_QUESTION: 'REP0111',
  COULD_NOT_DELETE_QUESTION: 'REP0112',
  NO_PATIENT_FOR_ID: 'REP0113',
  COULD_NOT_ASSIGN_QUESTIONNAIRE: 'REP0114',
  NO_CLIENT_FOR_ID: 'REP0115',
  COULD_NOT_CREATE_CLIENT: 'REP0116',
  COULD_NOT_UPDATE_CLIENT: 'REP0117',
  COULD_NOT_DELETE_CLIENT: 'REP0118',
  COULD_NOT_FIND_DEVICES: 'REP0119',
  COULD_NOT_FIND_DEVICE_LOG: 'REP0120',
  COULD_NOT_KARIE_VERSIONS: 'REP0121',
  COULD_NOT_SET_DEVICE_UPDATE: 'REP0122',
  COULD_NOT_GET_FW_VERSIONS: 'REP0123',
  COULD_NOT_INSERT_SCHEDULE_CHANGE: 'REP0124',
  NO_SCHEDULES_FOR_PATIENT: 'REP0125',
  COULD_NOT_SET_SEND_LOGS: 'REP0126',
  COULD_NOT_SET_LOGS_QUEUE_REF: 'REP0127',
  COULD_NOT_FETCH_SUPPORT_DOCS: 'REP0128',
  COULD_NOT_FETCH_SCHEDULE_CHANGES: 'REP0129',
  COULD_NOT_FETCH_PERMISSIONS: 'REP0130',
  COULD_NOT_CREATE_RELATIONSHIP: 'REP0131',
  COULD_NOT_CREATE_PERMISSIONS: 'REP0132',
  COULD_NOT_FIND_DEVICES_EVENTS: 'REP0151',
  COULD_NOT_DELETE_UPDATE_PACKAGE_RECORD: 'REP0157',
  COULD_NOT_CREATE_MANUFACTURING_DEVICES: 'REP0666',

  // LOGIN
  COULD_NOT_LOGIN_USER: 'LOG0101',

  // INEGRATION_ERROR_USER_INFO
  COULD_NOT_FETCH_USER_INFO: 'IEP0101',
  COULD_NOT_DOWNLOAD_LOG: 'IEP0102',

  // UNKNOWN
  UNKNOWN_SERVER_ERROR: 'UKN0000',
};
